import authRoles from '../../../auth/authRoles';
import ProviderStates from './ProviderStates';

const ProvidersConfig = {
  settings: {
    layout: {
      style: 'layoutMarketing',

      config: {
        header: {
          display: true
        },

        footer: {
          display: true
        }
      },
    },
  },

  auth: authRoles.onlyGuest,

  routes: [
    {
      path: '/directory/providers',
      element: <ProviderStates />,
    },
  ],
};

export default ProvidersConfig;
